import { first, orderBy } from 'lodash-es';

export interface GridSize {
  numberOfRows: number;
  numberOfColumns: number;
}

export interface GridCell {
  name?: string;
  size: number;
}

type GridResult = GridSize & {
  numberOfEmptyCells: number;
};

export function optimizeGridSize(
  cells: GridCell[],
  possibleRowNumbers: number[],
  possibleColumnNumbers: number[]
): GridSize {
  const result: GridResult[] = [];
  const margin = 1;

  if (cells.some((c) => possibleRowNumbers.some((row) => row < c.size))) {
    throw new Error(`Wrong input`);
  }

  const sumOfSizes = cells.reduce((acc, c) => acc + c.size, 0);

  possibleRowNumbers.forEach((row) => {
    possibleColumnNumbers.forEach((column) => {
      const tmpResult: GridResult = {
        numberOfColumns: column,
        numberOfRows: row,
        numberOfEmptyCells: 0,
      };

      let tmpRowRemainingLength: number = row;

      cells.forEach((cell) => {
        if (tmpRowRemainingLength - cell.size < 0) {
          tmpResult.numberOfEmptyCells += tmpRowRemainingLength;
          tmpRowRemainingLength = row - cell.size;
        } else {
          tmpRowRemainingLength -= cell.size;
        }
      });

      tmpResult.numberOfEmptyCells += tmpRowRemainingLength;

      if (sumOfSizes > tmpResult.numberOfRows && tmpResult.numberOfEmptyCells <= margin) {
        tmpResult.numberOfEmptyCells = 0;
      }

      result.push(tmpResult);
    });
  });
  const bestResult = first(
    orderBy(result, ['numberOfEmptyCells', 'numberOfRows'], ['asc', 'desc'])
  );

  return {
    numberOfColumns: bestResult.numberOfColumns,
    numberOfRows: bestResult.numberOfRows,
  };
}
